import React from "react";

const GroupTextArea = (props) => {
  const {
    label = "",
    name = "",
    divClass = "input-group",
    labelClass = "",
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      <label className={labelClass}>{label}</label>
      <div className={divClass}>
        <textarea
          name={name}
          id={props?.id ?? name}
          cols="45"
          rows="5"
          {...extra}
        />
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default GroupTextArea;
